export const DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ssZ';
export const DEFAULT_DATE_DISPLAY_FORMAT = 'd MMM';

export const BACKLOG = 'BACKLOG' as const;
export const BOARD = 'BOARD' as const;
export const SPRINT = 'SPRINT' as const;

export const INACTIVE_SPRINT = 'INACTIVE_SPRINT' as const;
export const ACTIVE_SPRINT = 'ACTIVE_SPRINT' as const;

export const TOP_OF_LIST = 'TOP_OF_LIST' as const;
export const BOTTOM_OF_LIST = 'BOTTOM_OF_LIST' as const;
export const BOTTOM_OF_CARD_GROUP = 'BOTTOM_OF_CARD_GROUP' as const;
export const BEFORE_CARD = 'BEFORE_CARD' as const;
export const TRANSITION_ZONE = 'TRANSITION_ZONE' as const;

export const NONE = 'NONE' as const;
export const ISSUE_LIST = 'ISSUE_LIST' as const;

export const SPRINT_STATE_FUTURE = 'FUTURE' as const;
export const SPRINT_STATE_ACTIVE = 'ACTIVE' as const;

export const SPRINT_MOVE_TO_TOP = 'SPRINT_MOVE_TO_TOP' as const;
export const SPRINT_MOVE_UP = 'SPRINT_MOVE_UP' as const;
export const SPRINT_MOVE_DOWN = 'SPRINT_MOVE_DOWN' as const;
export const SPRINT_MOVE_TO_BOTTOM = 'SPRINT_MOVE_TO_BOTTOM' as const;

export const DEFAULT_PARENT_ISSUE_TYPE_NAME = 'Epic' as const;

export const ESTIMATION_ROLLUP_BADGE_MAX = 999;

export const BACKLOG_LONG_TASKS_DND_MARK_NAME = 'backlog.long-tasks-dnd';
export const BACKLOG_LONG_TASKS_CARD_MOUSELEAVE_MARK_NAME = 'backlog.long-tasks-card-mouseleave';
export const BACKLOG_LONG_TASKS_CARD_DRAG_DROPTARGET_MARK_NAME =
	'backlog.long-tasks-card-drag-to-drop-target';

export const NONE_BACKLOG_STRATEGY = 'NONE' as const;
export const SPRINT_BACKLOG_STRATEGY = 'SPRINT' as const;
export const ISSUE_LIST_BACKLOG_STRATEGY = 'ISSUE_LIST' as const;
export const KANBAN_BACKLOG_STRATEGY = 'KANBAN_BACKLOG' as const;

export const REFRESH_SOURCE_FAILURE = 'FAILURE' as const;
export const REFRESH_SOURCE_REALTIME = 'REALTIME' as const;
export const REFRESH_SOURCE_KANBAN_CARD_MOVE_SUCCESS = 'KANBAN_CARD_MOVE_SUCCESS' as const;
export const REFRESH_SOURCE_GLOBAL_ISSUE_CREATE = 'GLOBAL_ISSUE_CREATE' as const;
export const REFRESH_SOURCE_SPRINT_COMPLETE = 'SPRINT_COMPLETE' as const;
export const REFRESH_SOURCE_STATUS_REMAPPED = 'STATUS_REMAPPED' as const;
export const REFRESH_SOURCE_ON_MOUNT = 'ON_MOUNT' as const;
export const REFRESH_SOURCE_ACTIVE_TAB = 'ACTIVE_TAB' as const;
export const REFRESH_SOURCE_POLLING = 'POLLING' as const;
export const REFRESH_SOURCE_ADD_ISSUE_TYPE_MODAL = 'ADD_ISSUE_TYPE_MODAL' as const;

export const APP_ID = 'software.backlog';
export const TEAM_NAME = 'a4t-tanuki';
export const PACKAGE_NAME = '@atlassian/jira-software-backlog';

export const EDIT_BOARD_CONFIG = 'EDIT_BOARD_CONFIG' as const;
export const DELETE_ISSUE = 'DELETE_ISSUE' as const;
export const CREATE_ISSUE = 'CREATE_ISSUE' as const;
export const MANAGE_SPRINT = 'MANAGE_SPRINT' as const;
export const EDIT_ISSUE = 'EDIT_ISSUE' as const;
export const VIEW_BOARD = 'VIEW_BOARD' as const;
export const ADMINISTER_BOARD = 'ADMINISTER_BOARD' as const;
export const BULK_CHANGE = 'BULK_CHANGE' as const;
export const ASSIGN_ISSUE = 'ASSIGN_ISSUE' as const;
export const TRANSITION_ISSUE = 'TRANSITION_ISSUE' as const;
export const ARCHIVE_ISSUE = 'ARCHIVE_ISSUE' as const;

export const ISSUE_COUNT_ID = 'issueCount_' as const;
export const ESTIMATION_TYPE_ID_PREFIX = 'field_' as const;
export const ORIGINAL_ESTIMATE_FIELD_ID = 'field_timeoriginalestimate' as const;
export const ORIGINAL_ESTIMATE_ID = 'timeoriginalestimate' as const;
export const STORY_POINTS_ID = 'field_customfield_' as const;
export const NUMERIC_ESTIMATE_FIELD_ID_PREFIX = 'customfield_' as const;

export const ISSUE_COUNT = 'ISSUE_COUNT' as const;
export const ORIGINAL_ESTIMATE = 'ORIGINAL_ESTIMATE' as const;
export const STORY_POINTS = 'STORY_POINTS' as const;

export const REMAINING_TIME_ESTIMATE = 'timeestimate' as const;

export const statisticFieldToEstimateType = {
	[ISSUE_COUNT_ID]: ISSUE_COUNT,
	[ORIGINAL_ESTIMATE_FIELD_ID]: ORIGINAL_ESTIMATE,
	[STORY_POINTS_ID]: STORY_POINTS,
};

export const statisticFieldPrefixes = [ISSUE_COUNT_ID, ORIGINAL_ESTIMATE_FIELD_ID, STORY_POINTS_ID];

export const CARD_TYPE = 'card' as const;
export const GROUP_TYPE = 'group' as const;
